// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FilterChipClose: React.FC<{ size?: number; color1?: string; className?: string }> = ({ size = 8, className }) => (
    <svg className={className} focusable="false" viewBox="0 0 8 8" width={size} height={size}>
        <path
            fill="currentColor"
            d="M6.47 7.341c.137.136.36.136.496 0a.35.35 0 0 0 0-.495L4.063 3.943 6.966 1.04a.35.35 0 0 0 0-.495.35.35 0 0 0-.495 0L3.568 3.448.665.545a.35.35 0 0 0-.495 0 .35.35 0 0 0 0 .495l2.903 2.903L.17 6.846a.35.35 0 0 0 0 .495c.136.136.36.136.495 0l2.903-2.903z"
        />
    </svg>
);

export default React.memo(FilterChipClose);
